import React from "react";
import Header from "../../components/header/header";
import Form from "../form";

const PageUtama = () => {
  return (
    <div className="max-w-[650px] mx-auto px-4">
      <Header />
      <Form />
    </div>
  );
};

export default PageUtama;
